import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { param } from 'jquery';
import { map, Observable } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { ciInterface, ciInterface2 } from 'src/app/util/interfaces/ci';
import { ciTypesInterface } from 'src/app/util/interfaces/ciTypes';
import { cmdbViewColumsI } from 'src/app/util/interfaces/cmdb/cmdbViewColumns';
import { CmdbDigitalTerm } from 'src/app/util/interfaces/cmdbDigitalTerm';
import { enduserInterface } from 'src/app/util/interfaces/enduser';
import { genericFormI } from 'src/app/util/interfaces/genericFormRMK';
import { locationInterface } from 'src/app/util/interfaces/locationInterface';
import { StatusInterfaceCMDB } from 'src/app/util/interfaces/statusInterface';
import { environment } from 'src/environments/environment';

export interface searchCiTableParameters {
	page: number;
	searchParameters: any;
	sortBy: string;
	sortDown: boolean;
	recount: boolean;
	showInactiveCis: boolean;
	noItemsSearch?: boolean;
	includeField?: string;
	ignoreCiList?: string;
	allowedCiTypeList?: string;
}
@Injectable({
	providedIn: 'root',
})
export class CmdbHomeScreenService {
	private searchCITableUrl = environment.baseApiUrl + 'cmdbhp';
	private searchCITableHeaderUrl = environment.baseApiUrl + 'cmdbhp/headers';
	private cmdbhpIdUrl = environment.baseApiUrl + 'cmdbhp/{idCiList}';
	private getAvailableLocationUrl = environment.baseApiUrl + 'cmdbhp/location';
	private getAvailableStatusUrl = environment.baseApiUrl + 'cmdbhp/status';
	private countSearchCITableUrl = environment.baseApiUrl + 'cmdbhp/count';
	private cmdbFieldUrl = environment.baseApiUrl + 'cmdbhp/cmdb/field';
	private cmdbFieldIdsUrl = environment.baseApiUrl + 'cmdbhp/cmdb/field/{idCiList}';
	private cmdbExportUrl = environment.baseApiUrl + 'cmdbhp/export';
	private getAvailableUsersUrl = environment.baseApiUrl + 'cmdbhp/users';

	private getImportAllFieldsUrl = environment.baseApiUrl + 'cmdbhp/import/field';
	private getImportHeadersUrl = environment.baseApiUrl + 'cmdbhp/import/template';

	private viewColumnsUrl = environment.baseApiUrl + 'cmdbhp/viewColumns';
	private viewColumnMeUrl = environment.baseApiUrl + 'cmdbhp/viewColumns/me';

	private getAvailableCiTypesUrl = environment.baseApiUrl + 'cmdb/citype';

	private updateCMDBUrl = environment.baseApiUrl + 'cmdbDigitalTerm/field/{idCMDB}';
	private postCmdbDigitalTermUrl = environment.baseApiUrl + 'cmdbDigitalTerm';
	private getCmdbDigitalTermUrl = environment.baseApiUrl + 'cmdbDigitalTerm/{idCMDB}';
	private updateCmdbDigitalTermUrl = environment.baseApiUrl + 'cmdbDigitalTerm/{idDigitalTerm}';
	private sendBatchTermByImportUrl = environment.baseApiUrl + 'cmdbDigitalTerm/sendBatchTermByImport';

	constructor(
		private AuthLoginService: AuthLoginService,
		private http: HttpClient
	) {}

	private headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	searchCITable(searchCiTableParameters_: searchCiTableParameters): Observable<{
		count: number;
		ciArr: ciInterface2[];
	}> {
		const headerParameter = {
			page: searchCiTableParameters_.page,
			sortBy: searchCiTableParameters_.sortBy,
			sortDown: searchCiTableParameters_.sortDown,
			recount: searchCiTableParameters_.recount,
			showActiveOnlyCis: !searchCiTableParameters_.showInactiveCis,
			noItemsSearch: searchCiTableParameters_.noItemsSearch,
		};
		if (searchCiTableParameters_.includeField != undefined) headerParameter['includeField'] = searchCiTableParameters_.includeField;
		if (searchCiTableParameters_.ignoreCiList != undefined) headerParameter['ignoreCiList'] = searchCiTableParameters_.ignoreCiList;
		if (searchCiTableParameters_.allowedCiTypeList != undefined)
			headerParameter['allowedCiTypeList'] = searchCiTableParameters_.allowedCiTypeList;
		for (const key of Object.keys(searchCiTableParameters_.searchParameters)) {
			headerParameter[key] =
				Array.isArray(searchCiTableParameters_.searchParameters[key]) && searchCiTableParameters_.searchParameters[key].length > 0
					? searchCiTableParameters_.searchParameters[key].join(',')
					: searchCiTableParameters_.searchParameters[key];
		}
		return this.http.get<{
			count: number;
			ciArr: ciInterface2[];
		}>(this.searchCITableUrl, {
			headers: this.headers,
			params: headerParameter,
		});
	}

	getCITableHeaders(): Observable<genericFormI[]> {
		return this.http.get<genericFormI[]>(this.searchCITableHeaderUrl, { headers: this.headers });
	}

	getFilteredCITableHeaders(searchParameters: any, showInactiveCis: boolean): Observable<genericFormI[]> {
		const headerParameter = {
			showActiveOnlyCis: !showInactiveCis,
		};

		for (const key of Object.keys(searchParameters)) {
			headerParameter[key] =
				Array.isArray(searchParameters[key]) && searchParameters[key].length > 0
					? searchParameters[key].join(',')
					: searchParameters[key];
		}

		return this.http.get<genericFormI[]>(this.searchCITableHeaderUrl + '/filtered', {
			headers: this.headers,
			params: headerParameter,
		});
	}

	countSearchCITable(searchParameters: any): Observable<number> {
		return this.http.get<number>(this.countSearchCITableUrl, {
			headers: this.headers,
			params: {
				general: searchParameters.general,
				// id: searchParams.id.join(','),
				// type: searchParams.type.join(','),
				// identification: searchParams.identification.join(','),
				// creation_date: searchParams.creation_date.join(','),
				// status: searchParams.status.join(','),
				// last_modification_date: searchParams.last_modification_date.join(','),
				// enduser: searchParams.enduser.join(','),
				// location: searchParams.location.join(','),
				// digitalTerm: searchParams.digitalTerm.join(','),
			},
		});
	}

	getAvailableCiTypes(): Observable<ciTypesInterface[]> {
		return this.http.get<JSON[]>(this.getAvailableCiTypesUrl, { headers: this.headers }).pipe(
			map((ciTypesRes) => {
				const newCiTypesArray: ciTypesInterface[] = [];
				ciTypesRes.forEach((ciType: any) => {
					const newCiType: ciTypesInterface = {
						id: ciType.id,
						label: ciType.label,
						type: ciType.type,
						icon: ciType.icon,
					};

					newCiTypesArray.push(newCiType);
				});

				return newCiTypesArray;
			})
		);
	}

	getAvailableLocation(): Observable<locationInterface[]> {
		return this.http.get<locationInterface[]>(this.getAvailableLocationUrl, { headers: this.headers });
	}

	getAvailableStatus(): Observable<StatusInterfaceCMDB[]> {
		return this.http.get<StatusInterfaceCMDB[]>(this.getAvailableStatusUrl, { headers: this.headers });
	}

	getAvailableUsers(): Observable<enduserInterface[]> {
		return this.http.get<JSON[]>(this.getAvailableUsersUrl, { headers: this.headers }).pipe(
			map((endusersRes: any) => {
				const newEnduserArray: enduserInterface[] = [];

				endusersRes.forEach((enduser: any) => {
					const newEnduser: enduserInterface = {
						id: enduser.id,
						fullName: enduser.full_name,
						email: enduser.email,
					};

					newEnduserArray.push(newEnduser);
				});

				return newEnduserArray;
			})
		);
	}

	deleteCis(idCis: string[]): Observable<any> {
		const cmdbhpIdUrl = this.cmdbhpIdUrl.replace('{idCiList}', idCis.join(','));
		return this.http.delete<any>(cmdbhpIdUrl, { headers: this.headers });
	}

	getCmdbField(): Observable<genericFormI[]> {
		return this.http.get<any>(this.cmdbFieldUrl, { headers: this.headers });
	}

	updateCis(idCis: string[], field: string, newValue: string, newValueText: string): Observable<any> {
		const cmdbFieldIdsUrl = this.cmdbFieldIdsUrl.replace('{idCiList}', idCis.join(','));
		return this.http.put<any>(
			cmdbFieldIdsUrl,
			{ field: field, newValue: newValue, newValueText: newValueText },
			{ headers: this.headers }
		);
	}

	exportCiTable(
		searchParameters: { [key: string]: any[] },
		sortBy: string,
		sortDown: boolean,
		showInactiveCis: boolean
	): Observable<any[][]> {
		const headerParameter = {
			sortBy: sortBy,
			sortDown: sortDown,
			showActiveOnlyCis: !showInactiveCis,
		};
		for (const key of Object.keys(searchParameters)) {
			headerParameter[key] =
				Array.isArray(searchParameters[key]) && searchParameters[key].length > 0
					? searchParameters[key].join(',')
					: searchParameters[key];
		}

		return this.http.get<any[][]>(this.cmdbExportUrl, {
			headers: this.headers,
			params: headerParameter,
		});
	}

	getImportHeaders(): Observable<genericFormI[]> {
		return this.http.get<any[]>(this.getImportHeadersUrl, { headers: this.headers, params: { toTable: false } }).pipe(
			map((headerDataRes) => {
				const returnData: genericFormI[] = [];
				for (const headerData of headerDataRes) {
					try {
						if (headerData.inputType == 'int') headerData.inputType = 'number';
						const newGenericFormI: genericFormI = new genericFormI(headerData.inputType);
						newGenericFormI.name = headerData.field;
						newGenericFormI.alias = headerData.alias;
						newGenericFormI.tip = headerData.sourceData;
						newGenericFormI.label = headerData.label;
						newGenericFormI.pseudoNames = headerData.reference;

						returnData.push(newGenericFormI);
					} catch {}
				}

				return returnData;
			})
		);
	}

	getImportHeadersTable(): Observable<any[][]> {
		return this.http.get<any[]>(this.getImportHeadersUrl, { headers: this.headers, params: { toTable: true } });
	}

	getImportAllFields(): Observable<{}> {
		return this.http.get<{}>(this.getImportAllFieldsUrl, { headers: this.headers });
	}

	updateCMDB(data: object, idCMDB: string): Observable<JSON> {
		const updateCMDBUrl = this.updateCMDBUrl.replace('{idCMDB}', idCMDB);

		return this.http.put<JSON>(updateCMDBUrl, data, { headers: this.headers });
	}

	getCmdbDigitalTerm(idCMDB: string): Observable<CmdbDigitalTerm> {
		const getCmdbDigitalTermUrl = this.getCmdbDigitalTermUrl.replace('{idCMDB}', idCMDB);

		return this.http.get<CmdbDigitalTerm>(getCmdbDigitalTermUrl, { headers: this.headers });
	}

	createCmdbDigitalTerm(data: CmdbDigitalTerm): Observable<any> {
		return this.http.post<any>(this.postCmdbDigitalTermUrl, data, { headers: this.headers });
	}

	updateCmdbDigitalTerm(idDigitalTerm: string, data: CmdbDigitalTerm): Observable<CmdbDigitalTerm[]> {
		const updateCmdbDigitalTermUrl = this.updateCmdbDigitalTermUrl.replace('{idDigitalTerm}', idDigitalTerm);

		return this.http.put<CmdbDigitalTerm[]>(updateCmdbDigitalTermUrl, data, { headers: this.headers });
	}

	getAvailableCMDBViewColumns(allowedCiTypeList?: string): Observable<genericFormI[]> {
		const parameters = {};
		if (allowedCiTypeList != undefined) parameters['allowedCiTypeList'] = allowedCiTypeList;
		return this.http.get<cmdbViewColumsI[]>(this.viewColumnsUrl, { headers: this.headers, params: parameters }).pipe(
			map((cmdbViewColumns) => {
				const returnGeneric = new genericFormI('multi-select');
				for (const field of cmdbViewColumns) {
					const genericItem = new genericFormI('item');
					genericItem.values.push(field.field);
					genericItem.rawValues.push(field.field);
					genericItem.name = field.field;
					genericItem.label = field.label;
					genericItem.rawInputType = field.inputType;
					returnGeneric.addItem(genericItem);
				}

				returnGeneric.items.sort((a, b) => {
					const labelValueA = a[0] == '_' ? a.replace('_', '') : a;
					const labelValueB = b[0] == '_' ? b.replace('_', '') : b;
					return labelValueA > labelValueB ? 1 : labelValueA < labelValueB ? -1 : 0;
				});

				returnGeneric.boxHeight = 180;
				returnGeneric.allowDragAndDrop = true;

				return [returnGeneric];
			})
		);
	}

	getAvailableCMDBViewColumnsMe(): Observable<{ field: string; label: string }[]> {
		const viewColumnsUrl = this.viewColumnsUrl + '?sortMode=userView';
		return this.http.get<{ field: string; label: string }[]>(viewColumnsUrl, { headers: this.headers });
	}

	saveCmdbViewColumns(columns: string[]): Observable<any> {
		return this.http.post<any>(this.viewColumnMeUrl, columns, { headers: this.headers });
	}

	sendBatchTermByImport(ids: string[]): Observable<any> {
		const parameters = { ids: ids.join(',') };
		return this.http.get<any>(this.sendBatchTermByImportUrl, { headers: this.headers, params: parameters });
	}
}
